import { inject, Injectable } from "@angular/core"
import { MessageService } from "primeng/api"
import { Observable } from "rxjs"
import { AngularFireFunctions } from "@angular/fire/compat/functions"

enum Severity {
  Error = "error",
  Success = "success",
  Warning = "warn",
}

@Injectable({
  providedIn: "root",
})
export class NotifService {
  functions = inject(AngularFireFunctions)
  sendMessageWhatsAppCloudFunction!: (d: any) => Observable<any>

  constructor(private messageService: MessageService) {
    this.sendMessageWhatsAppCloudFunction = this.functions.httpsCallable("sendWhatsAppMessage")
  }

  displayError(message: string, position = "", duration = 3000): void {
    this.displayMessage(Severity.Error, message, position, duration)
  }

  displaySuccess(message: string, position = ""): void {
    this.displayMessage(Severity.Success, message, position)
  }

  displayWarning(message: string, duration = 3000): void {
    this.displayMessage(Severity.Warning, message, "", duration)
  }

  private displayMessage(severity: Severity, message: string, position = "", duration = 3000): void {
    this.messageService.add({ severity, detail: message, life: duration, key: position })
  }

  public sendWhatsAppMessage(phoneNumber: string, params: any = null) {
    this.displayMessage(Severity.Success, "Un message Whatsapp a été envoyé")
    return this.sendMessageWhatsAppCloudFunction({
      number: phoneNumber,
      params: params,
    }).toPromise()
  }
}
